export const DisabledButtonStyle = {
  bgColor: '#F5F5F5',
  color: '#6F8296'
};